import { cloneElement } from 'react';
import cn from 'classnames';

export default function Logos({ title, className, logos, ...rest }) {
  return (
    <>
      <div className="mt-10 lg:mt-30" {...rest}>
        <h3
          className={cn(
            `text-base md:text-lg text-center font-medium`,
            className,
          )}
        >
          {title}
        </h3>

        <div className="mt-10 grid grid-cols-7 justify-items-center md:flex md:flex-wrap md:justify-center md:gap-y-10 mx-auto w-full max-w-4xl">
          {logos.map(({ icon, id }) => (
            <span
              key={id}
              className="flex justify-center items-center w-6 h-6 md:w-1/4 md:h-full"
            >
              {cloneElement(icon, {
                className: cn(icon.props?.className),
              })}
            </span>
          ))}
        </div>
      </div>
    </>
  );
}
